import { request } from '@/utils/request'

// 成长值每日记录增加观看时长,访问后返回当前时长和token
export function setGrowthDayRecord(data: any) {
  return request({
    url: '/zhongcaijie/h5/growth/setGrowthDayRecord',
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    data,
  })
}

// 分享课程并播放获取成长值
export function shareCurriculumAddGrowth(data: any) {
  return request({
    url: '/zhongcaijie/h5/growth/shareCurriculumAddGrowth',
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    data,
  })
}
